import styled from "styled-components";
import { values, colors, text } from "~/assets/js/theme/constants";
import { hideScrollbar } from "~/assets/js/theme/mixins";

export const Container = styled.div`
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    margin: 10px -10px 10px -10px;
    min-height: 100%;
`;

export const IngredientList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: ${(props) => (props.viewport.isMobile ? "nowrap" : "wrap")};
    ${(props) => (props.viewport.isMobile ? `overflow-y: hidden;` : "")}
    overflow-x: auto;
    ${(props) =>
        props.viewport.isMobile || props.viewport.isTablet
            ? `
                margin: 0 -12px 0 -12px; 
                padding-right: 12px;
                display: grid;
                grid-template-rows: auto auto;
                grid-auto-flow: column;
                justify-content: flex-start;`
            : ""}
    ${hideScrollbar};

    @media screen and (min-width: 568px) {
        margin-left: -32px;
        margin-right: -32px;
        padding-left: 24px;
        padding-right: 24px;
    }
`;

export const SubheaderNotice = styled.p`
    color: ${colors.LAYOUT.GRAY[700]};
    margin-top: -20px;
    margin-bottom: 10px;
    background-color: #e5fdec;
    padding: 8px;
    padding-right: 20px;
    border-radius: 8px;
    strong {
        color: ${colors.LAYOUT.GRAY[900]};
    }
`;

export const Chips = styled.div`
    display: flex;
    flex-direction: row;
    margin: ${(props) =>
        props.viewport.isMobile || props.viewport.isTablet
            ? ` 0 -12px 0 -12px;`
            : "10px"};
    ${(props) =>
        props.viewport.isMobile || props.viewport.isTablet
            ? `padding-left: 22px;`
            : ""}
    overflow-x: auto;
    overflow-y: hidden;
    ${hideScrollbar}
`;

export const RightTop = styled.div`
    display: flex;
    flex-direction: row;
`;

export const RightTopElement = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .top {
        color: ${colors.LAYOUT.GRAY[600]};
        font-family: ${text.REGULAR.FONT};
        font-weight: ${text.REGULAR.WEIGHT};
        font-size: 14px;
        line-height: 23px;

        @media screen and (min-width: 480px) {
            font-size: 16px;
        }

        &:after {
            content: "";
            clear: both;
            display: table;
        }
    }
    .bottom {
        color: ${colors.LAYOUT.GRAY[1000]};
        font-family: ${text.BOLD.FONT};
        font-weight: ${text.BOLD.WEIGHT};
        font-size: 18px;
        line-height: 21px;

        @media screen and (min-width: 768px) {
            font-size: 21px;
        }
    }
    .icon {
        margin-right: 10px;
        display: flex;
        flex-direction: row;
        float: left;
        margin-top: 3px;
    }
`;

export const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    //padding: 0 100px;
`;

export const ChosenOnes = styled.div`
    font-family: ${text.HEADLINE.FONT};
    font-weight: ${text.HEADLINE.WEIGHT};
    color: ${colors.BLACK};
    font-size: 21px;
    margin: 20px 16px 12px;
    line-height: 25px;

    @media screen and (min-width: 768px) {
        margin-left: 12px;
        margin-right: 12px;
    }
`;

export const SmallWidgetContainer = styled.div`
    flex: 1;
    height: 100%;
    overflow: auto;
    padding-bottom: 120px;
    ${hideScrollbar}
`;

export const OuterContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const BottomRightContainer = styled.div`
    width: 359px;
    position: fixed;
    bottom: 0;
    background-color: ${colors.WHITE};
    z-index: 2000;

    @media screen and (min-width: 768px) {
        padding-bottom: 12px;
        padding-left: 12px;
    }
`;

export const BottomButtonContainer = styled.div`
    padding-left: 16px;
    padding-right: 16px;
`;

export const Bottom = styled.div`
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    .grouptotal {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .total {
        font-weight: ${text.BOLD.WEIGHT};
        font-size: 18px;
        line-height: 26px;
        margin-right: 10px;
        margin-left: 10px;
        color: ${colors.LAYOUT.GRAY[1000]};
    }
    .vat {
        font-weight: ${text.REGULAR.WEIGHT};
        font-size: 14px;
        line-height: 26px;
        margin-left: 10px;
        color: ${colors.LAYOUT.GRAY[600]};
    }
    .green-club__tag p {
        font-size: 10px;
        line-height: 12.1px;
    }
    .green-club__tag {
        margin-right: 5px;
    }
`;

export const RightContent = styled.div`
    height: 100%;
    ${hideScrollbar}
`;

export const Right = styled.div`
    width: 360px;
    margin-left: 40px;
    border-left: 1px solid ${colors.LAYOUT.GRAY[400]};
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const StickyRight = styled.div`
    display: flex;
    overflow: hidden;
    flex-direction: column;
    height: 100vh;
`;

export const CatName = styled.div`
    font-size: 24px;
    line-height: 29px;
    font-family: ${text.HEADLINE.FONT};
    font-weight: ${text.HEADLINE.WEIGHT};
    color: ${colors.BLACK};
    margin-top: 40px;
    margin-left: 20px;
`;

export const CatSubheader = styled.div`
    font-size: 16px;
    font-family: ${text.REGULAR.FONT};
    font-weight: ${text.REGULAR.WEIGHT};
    color: ${colors.LAYOUT.GRAY[600]};
`;

export const MobileCart = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    overflow: hidden;
    padding: 20px 0;
    padding-top: 0;
`;

export const MOBILE_MINI_CART_MIN_HEIGHT = 60;

export const MobileMiniCart = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: ${MOBILE_MINI_CART_MIN_HEIGHT}px;
    background-color: ${colors.WHITE};
    padding: 0 20px 0 20px;
    .image {
        width: 47px;
        height: 47px;
    }
    .default-button {
        pointer-events: all;
    }
    .content {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 0 10px;
        font-family: ${text.REGULAR.FONT};
        font-weight: ${text.REGULAR.WEIGHT};
        font-size: 16px;
        line-height: 16px;
        color: ${colors.LAYOUT.GRAY[700]};
        .price {
            font-family: ${text.HEADLINE.FONT};
            font-weight: ${text.HEADLINE.WEIGHT};
            font-size: 18px;
            line-height: 1.2;
            color: ${colors.LAYOUT.GRAY[1000]};
        }
    }
`;

export const AddToMobileCart = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 10px;
`;
